import React from "react";
import Paper from "@material-ui/core/Paper";
import TablePagination from "@mui/material/TablePagination";
import jwtInterceptor from "../service/jwtInterceptor";
import TableRowUser from "../component/TableRowUser";
import {API_URL} from "../utils/constants";
import {Helmet} from "react-helmet";
import CustomBtn from "../component/customBtns/CustomBtn";
import {Box} from "@mui/material";
import Modal from "@mui/material/Modal";
import {InscriptionCollaborateur} from "../component/users/InscriptionCollaborateur";

const SuperAdminAgenceContainer = ({agenceId}) => {
    console.log("SuperAdminAgenceContainer - agenceId reçu:", agenceId);

    const [total, setTotal] = React.useState(0);
    const [dataTable, setDataTable] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [openCreateCollaboModal, setOpenCreateCollaboModal] = React.useState(false);
    const [selectedUser, setSelectedUser] = React.useState(null);
    const [error, setError] = React.useState(null);

    const columns = [
        {accessor: "username", show: "Nom"},
        {accessor: "firstname", show: "Prenom"},
        {accessor: "typeUser", show: "Type"},
        {accessor: "email", show: "E-mail"},
        {accessor: "createdAt", show: "Date inscription"},
        {accessor: "updatedAt", show: "Date dernier login"},
    ];

    const admin_columns = [
        {accessor: "username", show: "Nom"},
        {accessor: "firstname", show: "Prenom"},
        {accessor: "agence", show: "Agence"},
        {accessor: "email", show: "E-mail"},
        {accessor: "createdAt", show: "Date inscription"},
        {accessor: "updatedAt", show: "Date dernier login"},
    ];

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        getData(rowsPerPage, newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value));
        getData(event.target.value, page);
    };

    const getData = (perPage, page) => {
        searchfn({
            size: perPage,
            page: page,
        });
    };

    React.useEffect(() => {
        console.log("SuperAdminAgenceContainer - useEffect - agenceId:", agenceId);
        if (agenceId) {
            getData(rowsPerPage, page);
        }
    }, [agenceId]);

    const searchfn = (filter) => {
        console.log("SuperAdminAgenceContainer - searchfn - agenceId:", agenceId);
        setError(null);
        jwtInterceptor
            .get(
                `${API_URL}/user/agencies-users?size=${filter.size}&page=${filter.page}&agenceId=${agenceId}`
            )
            .then((res) => {
                console.log("Réponse API:", res.data);
                if (res.data && res.data.data) {
                    setTotal(res.data.data.total || 0);
                    setDataTable(res.data.data.results || []);
                } else {
                    setTotal(0);
                    setDataTable([]);
                }
            })
            .catch(error => {
                console.error("Erreur lors de la récupération des utilisateurs:", error);
                setError("Une erreur est survenue lors de la récupération des utilisateurs.");
                setTotal(0);
                setDataTable([]);
            });
    };

    const handleEditUser = (user) => {
        setSelectedUser(user);
        setOpenCreateCollaboModal(true);
    };

    const onCloseCreateUser = () => {
        setOpenCreateCollaboModal(false);
        setSelectedUser(null);
        getData(rowsPerPage, page);
    };

    const fontWeightTitle = {
        fontWeight: "600",
    };

    if (!agenceId) {
        console.log("SuperAdminAgenceContainer - Pas d'agenceId, retour null");
        return null;
    }

    // Filtrer les utilisateurs par type
    const collaborateurs = dataTable.filter(user => 
        user.userDetails && user.userDetails.typeUser === "collaborateur"
    );
    const admins = dataTable.filter(user => 
        user.userDetails && user.userDetails.typeUser === "agence_admin"
    );

    return (
        <div className="my-4 px-4">
            <Helmet>
                <title>Gérer les utilisateurs de l'agence - Mixdata</title>
            </Helmet>
            <Paper className="py-4 px-4 rounded shadow-none App-container sw-100 m-0">
                {error && (
                    <div className="alert alert-warning" role="alert">
                        {error}
                    </div>
                )}
                <div className="d-flex justify-content-between">
                    <h3
                        className="mb-4"
                        style={{...fontWeightTitle, width: "fit-content"}}
                    >
                        Collaborateur(s)
                    </h3>
                    <div style={{width: "fit-content"}}>
                        <CustomBtn
                            label="Collaborateur"
                            bgColor="#299CDB"
                            iconBg={"#3ba9e5"}
                            icon={"+"}
                            click={() => setOpenCreateCollaboModal(true)}
                        />
                    </div>
                </div>
                <div className="overflow-auto">
                    <table className="table" style={{margin: "auto"}}>
                        <thead
                            style={{
                                background: "#eeeeee",
                                borderBottom: "2px #DEE2E6 solid",
                                fontWeight: "normal",
                                color: "#363636",
                                marginBottom: "5px",
                            }}
                        >
                        <tr style={{width: "100%"}}>
                            {columns.map((field) => (
                                <th
                                    style={{width: "16.66%"}}
                                    scope="col"
                                    key={field.accessor}
                                >
                                    {field.show}
                                </th>
                            ))}
                            <th style={{width: "7.66%"}} scope="col" key={"actions"}>
                                Action
                            </th>
                        </tr>
                        </thead>
                        <tbody style={{paddingInline: "5px"}}>
                        {collaborateurs.length > 0 ? (
                            collaborateurs.map((row, index) => (
                                <TableRowUser
                                    key={row._source.id}
                                    keyIndex={index}
                                    row={row}
                                    onEdit={() => handleEditUser(row)}
                                />
                            ))
                        ) : (
                            <tr>
                                <td colSpan={7} className="text-center">
                                    Aucun collaborateur trouvé
                                </td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>
                <TablePagination
                    component="div"
                    count={total}
                    page={!page || page <= 0 ? 0 : page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    labelRowsPerPage="Lignes par page"
                    backIconButtonProps={{
                        "aria-label": "Précédent",
                        className: "PreviousBtn",
                    }}
                    nextIconButtonProps={{
                        "aria-label": "Suivant",
                        className: "NextBtn",
                    }}
                />
                <div className="admin_side mt-4">
                    <div className="d-flex justify-content-between">
                        <h3
                            className="mb-4"
                            style={{...fontWeightTitle, width: "fit-content"}}
                        >
                            Administrateur d'agence
                        </h3>
                    </div>
                    <div className="overflow-auto">
                        <table className="table" style={{margin: "auto"}}>
                            <thead
                                style={{
                                    background: "#eeeeee",
                                    borderBottom: "2px #DEE2E6 solid",
                                    fontWeight: "normal",
                                    color: "#363636",
                                    marginBottom: "5px",
                                }}
                            >
                            <tr style={{width: "100%"}}>
                                {admin_columns.map((field) => (
                                    <th
                                        style={{width: "16.66%"}}
                                        scope="col"
                                        key={field.accessor}
                                    >
                                        {field.show}
                                    </th>
                                ))}
                            </tr>
                            </thead>
                            <tbody style={{paddingInline: "5px"}}>
                            {admins.length > 0 ? (
                                admins.map((row, index) => (
                                    <TableRowUser
                                        userType="admin"
                                        key={row._source.id}
                                        keyIndex={index}
                                        row={row}
                                    />
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={6} className="text-center">
                                        Aucun administrateur trouvé
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                </div>
                <Modal
                    open={openCreateCollaboModal}
                    onClose={onCloseCreateUser}
                >
                    <Box
                        className="w-50 h-auto rounded p-3"
                        style={{height: "fit-content"}}
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            bgcolor: "background.paper",
                            boxShadow: 24,
                            p: 4,
                        }}
                    >
                        <InscriptionCollaborateur
                            onSubmitted={onCloseCreateUser}
                            userToEdit={selectedUser}
                            agenceId={agenceId}
                        />
                    </Box>
                </Modal>
            </Paper>
        </div>
    );
};

export default SuperAdminAgenceContainer; 